import React from 'react';
import Nav from './components/home/Nav';
import Hero from './components/home/Hero';
import StatBand from './components/home/StatBand';
import PredictiveAlgorithm from './components/home/PredictiveAlgorithm';
import ProductGallery from './components/home/ProductGallery';
import OurStory from './components/home/OurStory';
import BackedBy from './components/home/BackedBy';
import Faq from './components/home/Faq';
import CtaSection from './components/home/CtaSection';
import Footer from './Footer';

function Home() {
  return (
    <div className="bg-cream text-navy-deep font-sans">
      <Nav />
      <Hero />
      <StatBand />
      <PredictiveAlgorithm />
      <ProductGallery />
      <OurStory />
      <BackedBy />
      <Faq />
      <CtaSection />
      <Footer />
    </div>
  );
}

export default Home;
